import { render } from "./AppointmentsPage.vue?vue&type=template&id=3f627add&scoped=true"
import script from "./AppointmentsPage.vue?vue&type=script&lang=js"
export * from "./AppointmentsPage.vue?vue&type=script&lang=js"

import "./AppointmentsPage.vue?vue&type=style&index=0&id=3f627add&scoped=true&lang=css"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f627add"]])

export default __exports__